export var themeLight = 'light';
export var themeDark = 'dark';
export var defaultTheme = themeLight;
export var themes = [themeLight, themeDark];